import type {
  AppInstanceCreationFn,
  BaseSession,
} from '@zurich-framework/nextapp/types';
import type { AppPermission } from './permission';
import type { ApiConfig } from './server/apiAppInstance';

export const createAppInstance: AppInstanceCreationFn<
  ApiConfig,
  AppPermission,
  BaseSession<AppPermission>,
  {}
> = () => ({
  signIn: (_) => {
    throw new Error('sign in not implemented');
  },
  signOut: (_) => {
    throw new Error('sign out not implemented');
  },
  retrySignIn: (_) => {
    throw new Error('retry sign in not implemented');
  },
  errorViewHandler: () => {},
  createErrorObject: (_className) => {
    /*
      switch (className) {
        case 'yourCustomError':
          return Object.create(YourCustomError.prototype);
      } */
  },
  getGtmDataLayer: ({ debug }) => ({
    platform: {
      platform_name: 'vsga',
      platform_environment: debug ? 'dev' : 'prod',
    },
  }),
});
